export const community = {
  heading: 'Community',
  description: 'Check out these links for the latest development at PayPal.',
  data: [
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/play.png',
      tag: {
        text: 'API',
      },
      heading: 'Video content',
      description: 'Watch developers walkthrough advanced integrations.',
      link: 'https://www.youtube.com/channel/UCvNxReTAQudFN4RQth9r_6A/videos?app=desktop',
    },
    {
      image: 'https://www.paypalobjects.com/ppdevdocs/multipartyimages/faq.png',
      tag: {
        text: 'Help',
        bgColor: 'yellow',
      },
      heading: 'FAQs',
      description: 'Get answers to common technical questions.',
      link: 'https://www.paypal.com/us/smarthelp/home?_ga=1.230317916.1793435819.1627333926',
    },
    {
      image:
        'https://www.paypalobjects.com/ppdevdocs/multipartyimages/code.png',
      tag: {
        text: 'Learn More',
        bgColor: 'grey',
      },
      heading: 'PayPal GitHub',
      description: 'Check out the latest repositories on GitHub.',
      link: 'https://github.com/paypal',
    },
  ],
}
